/** @format */
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import OrdersContentColumn from "../content/OrdersContentColumn";
import SectionItem from "../../orders-new/section-item";
import OrdersSectionItemInfoColumn from "../../orders-new/section-item/components/OrdersSectionItemInfoColumn";
import OrdersDatePicker from "../date-picker-new";
import OrdersLocationInfo from "../location-info";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddYourCity from "../add-your-city/AddYourCity";
import CustomSelect from "../../custom/custom-select";
import OrdersMap from "../../orders-new/map/OrdersMap";
import OrdersSectionItemCreate from "../../orders-new/section-item/components/OrdersSectionItemCreate";
import AddIntermediatePoint from "../../orders-new/section-item/components/AddIntermediatePoint";
import CopyIcon from "../../shared/icons/CopyIcon";
import { useScreenSize } from "../../../hooks/useScreenSize";
import { useOrderLimit } from "../../../hooks/useClientLimits";
import AccessDeniedModal from "../../shared/SubscriptionModal/AccessDeniedModal";
import UnifiedOrderDetails from "../unified-create/UnifiedOrderDetails";
import UnifiedCarrierSelection from "../unified-create/UnifiedCarrierSelection";
import { validateNewOrder } from "../../../pages/orders/utils/newOrderPayload";
import creationStyles from "../unified-create/UnifiedOrderCreation.module.scss";

const OrdersCreateDesktopView = (props) => {
  const {
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    type,
    addressTo,
    setAddressTo,
    recipientUpdate,
    addressFrom,
    setAddressFrom,
    setRecipientUpdate,
    recipientName,
    setRecipientName,
    recipientPhone,
    setRecipientPhone,
    volume,
    weight,
    weightUnit,
    category,
    setAlgoPrice,
    setPredictedPrice,
    createLoading,
    createOrder,
    orderCalculation,
    onResetPrice,
    saveDraft,
    setIsСallСities,
    isLoadingMap,
    routeData,
    routeStartCity,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    setPoints,
    senderName,
    setSenderName,
    setSenderPhone,
    setRouteDistance,
    setRouteDuration,
    isCopy = false,
    isEdit = false,
    headTitle = "",
    routeDistance,
  } = props;
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const { isMobileView } = useScreenSize();
  const { orderLimit } = useOrderLimit();

  const [isOpenAddFrom, setIsOpenAddFrom] = useState(false);
  const [isOpenAddTo, setIsOpenAddTo] = useState(false);
  const [initialCityNameFrom, setInitialCityNameFrom] = useState("");
  const [initialCityNameTo, setInitialCityNameTo] = useState("");

  const [isDisplayModal, changeDisplayModal] = useState(false);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if ((user && user?.permissions?.includes("restricted_view")) || (user && user?.permissions && !user?.permissions?.includes("order_create"))) {
      changeDisplayModal(true);
    } else if (!isEdit && user && user?.role && !user?.role?.isUnlimited && orderLimit !==null && orderLimit <= 0) {
      changeDisplayModal(true);
    }
  }, [user, orderLimit, isEdit]);

  useEffect(() => {
    if (
      cityFrom &&
      countryFrom &&
      cityTo &&
      countryTo &&
      category &&
      type &&
      weight &&
      volume &&
      routeDistance
    ) {
      orderCalculation();
    } else {
      setAlgoPrice(0);
      setPredictedPrice({});
    }
  }, [cityFrom, countryFrom, cityTo, countryTo, category, type, weight, volume, routeDistance, pickUpDate, weightUnit]);

  const handleCountryFromChange = (country) => {
    if (country?.id === countryFrom?.id) return;
    onResetPrice();
    setCountryFrom(country);
    setCityFrom(null);
    setAddressFrom(null);
    setAddressIdFrom(null);
    setCoordinatesFrom(null);
  };

  const handleCountryToChange = (country) => {
    if (country?.id === countryTo?.id) return;
    onResetPrice();
    setCountryTo(country);
    setCityTo(null);
    setAddressTo(null);
    setAddressIdTo(null);
    setCoordinatesTo(null);
  };

  const submitFormData = () => {
    if (createLoading) return;
    if (user && (!user?.permissions?.includes("order_create") || (!isEdit && !user?.role?.isUnlimited && orderLimit <= 0))) {
      changeDisplayModal(true);
      return;
    }
    const permission = props.assignmentMethod === "DirectAssignment" ? "expeditor_view" : "tender_view";
    if (!user?.permissions?.includes(permission)) {
      toast.info(t("common.noAccessSupportMessage"));
      return;
    }
    const validationErrors = validateNewOrder(props, t);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length) {
      toast.error(t("unifiedOrder.checkFields"));
      return;
    }
    createOrder();
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Info */}
      <OrdersContentColumn position className={creationStyles.layout}>
        {(isCopy || isEdit) && (
          <SectionItem
            column={2}
            title={headTitle}
            isShadow
            isCopy
            prefixStart={<CopyIcon fill="#6D7885" />}
            isCunter={false}
          ></SectionItem>
        )}

        <SectionItem column={2} title={t('ordersCreateDesktop.fromSection.title')} counter={1} isShadow>
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t('ordersCreateDesktop.fromSection.countryLabel')}>
              <CustomSelect
                key={"countries-from"}
                labelText={t('ordersCreateDesktop.fromSection.countryShortLabel')}
                placeholder={t('ordersCreateDesktop.fromSection.countryLabel')}
                errorText={!countryFrom && errors?.countryFrom}
                options={countries}
                defaultValue={countryFrom}
                returnObject
                onSubmit={handleCountryFromChange}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn title={t('ordersCreateDesktop.fromSection.cityLabel')}>
              <CustomSelect
                labelText={t('ordersCreateDesktop.fromSection.cityShortLabel')}
                placeholder={t('ordersCreateDesktop.fromSection.cityLabel')}
                errorText={!cityFrom && errors?.cityFrom}
                options={citiesFrom}
                defaultValue={cityFrom}
                returnObject
                isDisabled={!countryFrom}
                onSubmit={(item) => {
                  onResetPrice();
                  setCityFrom(item);
                  setAddressFrom(null);
                  setAddressIdFrom(null);
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={(searchValue) => {
                  setInitialCityNameFrom(searchValue);
                  setIsOpenAddFrom(true);
                }}
              />
              {isOpenAddFrom && (
                <AddYourCity
                  setCountry={handleCountryFromChange}
                  setCity={setCityFrom}
                  countries={countries}
                  country={countryFrom}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityFrom}
                  isOpenAdd={isOpenAddFrom}
                  setIsOpenAdd={setIsOpenAddFrom}
                  initialCityName={initialCityNameFrom}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={isMobileView ? "1fr" : "1fr 1.3fr"}>
            <OrdersDatePicker
              date={pickUpDate}
              timeStart={pickUpStartTime}
              timeEnd={pickUpEndTime}
              minDate={minPickDate}
              isSender
              isEditable
              setDate={setPickUpDate}
              setTimeStart={setPickUpStartTime}
              setTimeEnd={setPickUpEndTime}
              labelText={t('ordersCreateDesktop.fromSection.dateLabel')}
              labelTimeStart={t('ordersCreateDesktop.fromSection.timeStartLabel')}
              labelTimeEnd={t('ordersCreateDesktop.fromSection.timeEndLabel')}
              placeholderText={t('ordersCreateDesktop.fromSection.datePlaceholder')}
              errorDate={!pickUpDate && errors?.pickUpDate}
              errorTimeStart={!pickUpStartTime && errors?.pickUpStartTime}
              errortimeEnd={!pickUpEndTime && errors?.pickUpEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t('ordersCreateDesktop.fromSection.senderLabel')}
              errorText={!addressFrom && errors?.addressFrom}
              isSender
              isEditable
              forceOpenDropdown={!!addressTo}
              forceOpenDropdownCount={recipientUpdate}
              // companyName={user?.companyName}
              companyName={senderName}
              countries={countries}
              countrySelected={countryFrom}
              citySelected={cityFrom}
              address={addressFrom}
              onCoordinates={setCoordinatesFrom}
              onRecipientPhone={setSenderPhone}
              onRecipientEmail={props.setSenderEmail}
              phoneNumber={props.senderPhone}
              onAddressId={setAddressIdFrom}
              onChangeResipient={setSenderName}
              onChangeAddress={(item) => {
                setAddressFrom(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onChangeCountry={handleCountryFromChange}
              onChangeCity={(city) => {
                setCityFrom(city);
              }}
            />
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <AddIntermediatePoint
          points={points}
          setPoints={setPoints}
          countries={countries}
          cities={citiesTo}
          setIsOpenAddTo={setIsOpenAddTo}
          errors={errors?.points}
          user={user}
          pickUpDate={pickUpDate}
        />

        <SectionItem column={2} title={t('ordersCreateDesktop.toSection.title')} counter={2 + points.length} isShadow>
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t('ordersCreateDesktop.toSection.countryLabel')}>
              <CustomSelect
                labelText={t('ordersCreateDesktop.fromSection.countryShortLabel')} // Reusing 'Country' label
                placeholder={t('ordersCreateDesktop.toSection.countryLabel')}
                options={countries}
                errorText={!countryTo && errors?.countryTo}
                defaultValue={countryTo}
                returnObject
                onSubmit={handleCountryToChange}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn title={t('ordersCreateDesktop.toSection.cityLabel')}>
              <CustomSelect
                labelText={t('ordersCreateDesktop.fromSection.cityShortLabel')}
                placeholder={t('ordersCreateDesktop.toSection.cityLabel')}
                errorText={!cityTo && errors?.cityTo}
                options={citiesTo}
                defaultValue={cityTo}
                returnObject
                isDisabled={!countryTo}
                onSubmit={(item) => {
                  onResetPrice();
                  setCityTo(item);
                  setAddressTo(null);
                  setCoordinatesTo(null);
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={(searchValue) => {
                  setInitialCityNameTo(searchValue);
                  setIsOpenAddTo(true);
                }}
              />
              {isOpenAddTo && (
                <AddYourCity
                  setCountry={handleCountryToChange}
                  setCity={setCityTo}
                  country={countryTo}
                  countries={countries}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityTo}
                  isOpenAdd={isOpenAddTo}
                  setIsOpenAdd={setIsOpenAddTo}
                  initialCityName={initialCityNameTo}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={isMobileView ? "1fr" : "1fr 1.3fr"}>
            <OrdersDatePicker
              date={deliveryDate}
              timeStart={deliveryStartTime}
              timeEnd={deliveryEndTime}
              minDate={points.length > 0 ? (points[points.length - 1]?.shippingDate || pickUpDate) : pickUpDate}
              isEditable
              setDate={setDeliveryDate}
              setTimeStart={setDeliveryStartTime}
              setTimeEnd={setDeliveryEndTime}
              labelText={t('ordersCreateDesktop.toSection.dateLabel')}
              labelTimeStart={t('ordersCreateDesktop.fromSection.timeStartLabel')} // Reusing 'Time' label
              labelTimeEnd={t('ordersCreateDesktop.fromSection.timeEndLabel')} // Reusing 'To' label
              placeholderText={t('ordersCreateDesktop.fromSection.datePlaceholder')} // Reusing 'Enter date' placeholder
              errorDate={!deliveryDate && errors?.deliveryDate}
              errorTimeStart={!deliveryStartTime && errors?.deliveryStartTime}
              errortimeEnd={!deliveryEndTime && errors?.deliveryEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t('ordersCreateDesktop.toSection.recipientLabel')}
              errorText={!addressTo && errors?.addressTo}
              isEditable
              forceOpenDropdown={!addressFrom}
              forceOpenDropdownCount={recipientUpdate}
              countries={countries}
              address={addressTo}
              countrySelected={countryTo}
              citySelected={cityTo}
              companyName={recipientName}
              phoneNumber={recipientPhone}
              onChangeAddress={(item) => {
                setAddressTo(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onRecipientPhone={setRecipientPhone}
              onRecipientEmail={props.setRecipientEmail}
              onCoordinates={setCoordinatesTo}
              onAddressId={setAddressIdTo}
              onChangeResipient={setRecipientName}
              onChangeCountry={handleCountryToChange}
              onChangeCity={(city) => {
                setCityTo(city);
              }}
            />

          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <UnifiedOrderDetails {...props} errors={errors || {}} />
        <UnifiedCarrierSelection {...props} errors={errors || {}} />

        <SectionItem isShadow isPSmall>
          <OrdersSectionItemCreate
            isRailway={props.isRailway}
            onSubmit={submitFormData}
            onSubmitDraft={saveDraft}
            isLoading={createLoading}
            isHidden={!saveDraft}
            isDisabled={createLoading}
            submitText={isEdit ? t("common.save") : undefined}
          />
        </SectionItem>
      </OrdersContentColumn>

      <OrdersMap
        isLoadingMap={isLoadingMap}
        routeData={routeData}
        routeStartCity={routeStartCity}
        cityFrom={cityFrom}
        cityTo={cityTo}
        addressIdFrom={addressIdFrom}
        addressIdTo={addressIdTo}
        coordinatesFrom={coordinatesFrom}
        coordinatesTo={coordinatesTo}
        points={points}
        setRouteDistance={setRouteDistance}
        setRouteDuration={setRouteDuration}
      />

      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}
    </div>
  );
};

export default OrdersCreateDesktopView;
